module.exports = __webpack_public_path__ + "static/media/info-icon.a4d8f42d.svg";